import { FC } from 'react'
import { IOpeningHours } from '../../interfaces/cityCardDetails'

interface Props {
  openHours: IOpeningHours
}
const OpenHours: FC<Props> = ({ openHours }) => {
  const getOpenHoursForDay = (
    isHoliday: string,
    mustReserve: string,
    openingTime: string,
    closingTime: string
  ) => {
    const formatTime = (time: string) => {
      const splitted = time.split(':')
      return `${splitted[0]}:${splitted[1]}`
    }
    if (isHoliday === '1') return <>Szünnap</>
    if (mustReserve === '1') return <>Bejelentkezés szükséges</>
    return (
      <>
        {' '}
        {formatTime(openingTime)} - {formatTime(closingTime)}
      </>
    )
  }
  return (
    <p className="font-montserrat font-regular text-[1.8rem] leading-[26px] pt-10">
      Nyitva:
      <br />
      Hétfő:
      {getOpenHoursForDay(
        openHours.monday_is_holiday,
        openHours.monday_must_reserve,
        openHours.monday_opening_time,
        openHours.monday_closing_time
      )}
      <br />
      Kedd:
      {getOpenHoursForDay(
        openHours.tuesday_is_holiday,
        openHours.tuesday_must_reserve,
        openHours.tuesday_opening_time,
        openHours.tuesday_closing_time
      )}
      <br />
      Szerda:
      {getOpenHoursForDay(
        openHours.wednesday_is_holiday,
        openHours.wednesday_must_reserve,
        openHours.wednesday_opening_time,
        openHours.wednesday_closing_time
      )}
      <br />
      Csütörtök:
      {getOpenHoursForDay(
        openHours.thursday_is_holiday,
        openHours.thursday_must_reserve,
        openHours.thursday_opening_time,
        openHours.thursday_closing_time
      )}
      <br />
      Péntek:
      {getOpenHoursForDay(
        openHours.friday_is_holiday,
        openHours.friday_must_reserve,
        openHours.friday_opening_time,
        openHours.friday_closing_time
      )}
      <br />
      Szombat:
      {getOpenHoursForDay(
        openHours.saturday_is_holiday,
        openHours.saturday_must_reserve,
        openHours.saturday_opening_time,
        openHours.saturday_closing_time
      )}
      <br />
      Vasárnap:
      {getOpenHoursForDay(
        openHours.sunday_is_holiday,
        openHours.sunday_must_reserve,
        openHours.sunday_opening_time,
        openHours.sunday_closing_time
      )}
    </p>
  )
}

export default OpenHours
